/* ======================================================================
   WONDERNEST — PREMIUM INTERACTIONS (wnx)
   Starfields, reveals, split text, tilt, magnetic buttons, counters,
   reels, header, drawer, search, product page logic.
   ====================================================================== */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement, win = window;
  var reduce = win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = win.matchMedia && win.matchMedia('(pointer: fine)').matches;
  win.__xReady = true;
  if (!reduce && 'IntersectionObserver' in win) root.classList.add('x-anim'); else { root.classList.remove('x-anim'); root.classList.add('no-x-anim'); }

  function $(s, c) { return (c || doc).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); }
  function onReady(fn) { if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', fn); else fn(); }

  /* ---------------- split text into words ---------------- */
  function split(el) {
    if (el.dataset.xSplitDone) return; el.dataset.xSplitDone = '1';
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var parts = n.textContent.split(/(\s+)/), frag = doc.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(doc.createTextNode(p)); return; }
            var w = doc.createElement('span'); w.className = 'x-w';
            var s = doc.createElement('span'); s.textContent = p; s.style.setProperty('--i', i++);
            w.appendChild(s); frag.appendChild(w);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && !n.classList.contains('x-em')) {
          walk(n);
        } else if (n.nodeType === 1) {
          var w2 = doc.createElement('span'); w2.className = 'x-w';
          n.parentNode.insertBefore(w2, n); var s2 = doc.createElement('span'); s2.style.setProperty('--i', i++);
          w2.appendChild(s2); s2.appendChild(n);
        }
      });
    })(el);
  }

  /* ---------------- reveal on scroll ---------------- */
  var io = ('IntersectionObserver' in win) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      if (e.target.hasAttribute('data-x-count')) count(e.target);
      if (e.target.hasAttribute('data-x-ring')) ring(e.target);
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }) : null;

  function scan(scope) {
    $$('[data-x-split]', scope).forEach(function (el) { if (!reduce) split(el); el.classList.add('x-split'); });
    $$('[data-x-reveal], [data-x-split], [data-x-count], [data-x-ring]', scope).forEach(function (el) {
      if (io && !reduce) io.observe(el); else { el.classList.add('is-in'); if (el.hasAttribute('data-x-count')) count(el, true); if (el.hasAttribute('data-x-ring')) ring(el); }
    });
  }

  /* ---------------- counters ---------------- */
  function count(el, instant) {
    var raw = el.getAttribute('data-x-count') || el.textContent;
    var m = raw.match(/^([^\d]*)([\d.,]+)(.*)$/);
    if (!m) return;
    var pre = m[1], num = parseFloat(m[2].replace(/,/g, '')), post = m[3];
    var dec = (m[2].split('.')[1] || '').length, comma = m[2].indexOf(',') > -1;
    if (instant || reduce) { el.textContent = raw; return; }
    var t0 = null, dur = 2000;
    function fmt(v) { var s = v.toFixed(dec); if (comma) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ','); return pre + s + post; }
    function step(t) { if (!t0) t0 = t; var p = Math.min(1, (t - t0) / dur); var e = 1 - Math.pow(1 - p, 4); el.textContent = fmt(num * e); if (p < 1) requestAnimationFrame(step); else el.textContent = raw; }
    requestAnimationFrame(step);
  }
  function ring(el) {
    var fg = $('.x-ring__fg', el); if (!fg) return;
    var pct = parseFloat(el.getAttribute('data-x-ring')) || 0;
    var len = 2 * Math.PI * 85;
    fg.style.strokeDasharray = len; fg.style.strokeDashoffset = len;
    requestAnimationFrame(function () { fg.style.strokeDashoffset = len * (1 - Math.min(pct, 100) / 100); });
  }

  /* ---------------- starfield ---------------- */
  function stars(canvas) {
    if (!canvas || canvas.dataset.xOn) return; canvas.dataset.xOn = '1';
    var ctx = canvas.getContext('2d'), dpr = Math.min(win.devicePixelRatio || 1, 2), W, H, pts = [], shoot = null, mx = 0, my = 0, raf, visible = true;
    function size() {
      var r = canvas.getBoundingClientRect(); W = r.width; H = r.height; canvas.width = W * dpr; canvas.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = Math.min(260, Math.round(W * H / 5200)); pts = [];
      for (var i = 0; i < n; i++) pts.push({ x: Math.random() * W, y: Math.random() * H, z: Math.random() * .9 + .1, r: Math.random() * 1.3 + .25, tw: Math.random() * Math.PI * 2, s: Math.random() * .02 + .005 });
    }
    function draw() {
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < pts.length; i++) {
        var p = pts[i]; p.tw += p.s;
        var a = .35 + Math.sin(p.tw) * .35 + p.z * .3;
        var x = p.x + mx * p.z * 18, y = p.y + my * p.z * 18;
        ctx.beginPath(); ctx.arc(x, y, p.r * p.z * 1.6, 0, 6.283); ctx.fillStyle = 'rgba(255,255,255,' + a.toFixed(3) + ')'; ctx.fill();
        if (p.r > 1.3 && p.z > .7) { ctx.beginPath(); ctx.arc(x, y, p.r * 4, 0, 6.283); ctx.fillStyle = 'rgba(255,214,140,' + (a * .12).toFixed(3) + ')'; ctx.fill(); }
      }
      if (!shoot && Math.random() < .006) shoot = { x: Math.random() * W * .7 + W * .3, y: Math.random() * H * .4, l: 0 };
      if (shoot) {
        shoot.l += 14; var sx = shoot.x - shoot.l, sy = shoot.y + shoot.l * .45;
        var g = ctx.createLinearGradient(sx, sy, sx + 120, sy - 54); g.addColorStop(0, 'rgba(255,230,170,.9)'); g.addColorStop(1, 'rgba(255,230,170,0)');
        ctx.strokeStyle = g; ctx.lineWidth = 1.6; ctx.beginPath(); ctx.moveTo(sx, sy); ctx.lineTo(sx + 120, sy - 54); ctx.stroke();
        if (shoot.l > W * .8) shoot = null;
      }
      if (visible) raf = requestAnimationFrame(draw);
    }
    size(); win.addEventListener('resize', function () { size(); });
    if (fine) canvas.parentNode.parentNode.addEventListener('mousemove', function (e) { var r = canvas.getBoundingClientRect(); mx = (e.clientX - r.left) / r.width - .5; my = (e.clientY - r.top) / r.height - .5; });
    if (reduce) { draw(); cancelAnimationFrame(raf); return; }
    if ('IntersectionObserver' in win) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) { cancelAnimationFrame(raf); raf = requestAnimationFrame(draw); } }).observe(canvas);
    raf = requestAnimationFrame(draw);
  }

  /* ---------------- tilt + magnetic ---------------- */
  function tilt(el) {
    if (!fine || reduce || el.dataset.xT) return; el.dataset.xT = '1';
    var target = $(el.getAttribute('data-x-tilt') || '', el) || el, max = parseFloat(el.dataset.xMax || 10);
    el.addEventListener('mousemove', function (e) {
      var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      target.style.transform = 'rotateY(' + (x * max * 2) + 'deg) rotateX(' + (-y * max * 2) + 'deg) rotateZ(-2deg)';
    });
    el.addEventListener('mouseleave', function () { target.style.transform = ''; });
  }
  function magnet(el) {
    if (!fine || reduce || el.dataset.xM) return; el.dataset.xM = '1';
    el.addEventListener('mousemove', function (e) { var r = el.getBoundingClientRect(); el.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * .18) + 'px,' + ((e.clientY - r.top - r.height / 2) * .3 - 3) + 'px)'; });
    el.addEventListener('mouseleave', function () { el.style.transform = ''; });
  }

  /* ---------------- parallax ---------------- */
  var px = [];
  function parallaxTick() {
    var vh = win.innerHeight;
    px.forEach(function (el) { var r = el.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return; var k = parseFloat(el.getAttribute('data-x-parallax')) || .1; el.style.translate = '0 ' + ((r.top + r.height / 2 - vh / 2) * -k).toFixed(1) + 'px'; });
  }

  /* ---------------- header ---------------- */
  function header() {
    var h = $('[data-x-header]'); if (!h) return;
    var last = 0, prog = $('.x-progress');
    function onScroll() {
      var y = win.scrollY || 0;
      h.classList.toggle('is-scrolled', y > 10);
      if (y > 420 && y > last + 4) h.classList.add('is-hidden'); else if (y < last - 4 || y < 200) h.classList.remove('is-hidden');
      last = y;
      if (prog) { var max = doc.documentElement.scrollHeight - win.innerHeight; prog.style.setProperty('--p', max > 0 ? (y / max).toFixed(4) : 0); }
      if (px.length) parallaxTick();
    }
    win.addEventListener('scroll', function () { requestAnimationFrame(onScroll); }, { passive: true }); onScroll();
  }
  function overlays() {
    $$('[data-x-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var t = doc.getElementById(btn.getAttribute('data-x-open')); if (!t) return; e.preventDefault();
        t.classList.add('is-open'); t.setAttribute('aria-hidden', 'false'); doc.body.style.overflow = 'hidden';
        setTimeout(function () { win.dispatchEvent(new Event('resize')); }, 60);
        var f = $('input', t); if (f) setTimeout(function () { f.focus(); }, 250);
      });
    });
    $$('[data-x-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { var t = btn.closest('.x-drawer, .x-search'); if (t) { t.classList.remove('is-open'); t.setAttribute('aria-hidden', 'true'); doc.body.style.overflow = ''; } });
    });
    doc.addEventListener('keyup', function (e) { if (e.key === 'Escape') $$('.x-drawer.is-open, .x-search.is-open').forEach(function (t) { t.classList.remove('is-open'); doc.body.style.overflow = ''; }); });
  }

  /* ---------------- reels ---------------- */
  function reels(scope) {
    $$('[data-x-reels]', scope).forEach(function (wrap) {
      if (wrap.dataset.xOn) return; wrap.dataset.xOn = '1';
      var rail = $('.x-reels__rail', wrap); if (!rail) return;
      var vids = $$('video', rail);
      vids.forEach(function (v) { v.muted = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.loop = true; v.removeAttribute('controls'); });
      if ('IntersectionObserver' in win) {
        var vio = new IntersectionObserver(function (es) { es.forEach(function (e) { var v = e.target; if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); }); }, { threshold: .5 });
        vids.forEach(function (v) { vio.observe(v); });
      }
      $$('.x-reel__mute', rail).forEach(function (b) {
        b.addEventListener('click', function () {
          var v = $('video', b.closest('.x-reel')); if (!v) return;
          var willUnmute = v.muted;
          vids.forEach(function (o) { o.muted = true; var ob = $('.x-reel__mute', o.closest('.x-reel')); if (ob) ob.classList.remove('is-on'); });
          v.muted = !willUnmute; if (willUnmute) { b.classList.add('is-on'); v.play(); }
        });
      });
      var step = function () { var c = $('.x-reel', rail); return c ? c.getBoundingClientRect().width + 22 : 300; };
      var prev = $('[data-x-prev]', wrap), next = $('[data-x-next]', wrap);
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
      if (fine) {
        var down = false, sx, sl, moved;
        rail.addEventListener('mousedown', function (e) { down = true; moved = false; sx = e.pageX; sl = rail.scrollLeft; rail.classList.add('is-grab'); });
        win.addEventListener('mouseup', function () { down = false; rail.classList.remove('is-grab'); });
        rail.addEventListener('mousemove', function (e) { if (!down) return; var d = e.pageX - sx; if (Math.abs(d) > 4) moved = true; rail.scrollLeft = sl - d; });
        rail.addEventListener('click', function (e) { if (moved && !e.target.closest('.x-reel__mute')) { e.preventDefault(); e.stopPropagation(); } }, true);
      }
    });
  }

  /* ---------------- marquee duplication safety ---------------- */
  function marquees(scope) {
    $$('[data-x-marquee]', scope).forEach(function (t) {
      if (t.dataset.xOn) return; t.dataset.xOn = '1';
      if (t.scrollWidth < win.innerWidth * 2.2) { var c = t.innerHTML; t.innerHTML = c + c; }
    });
  }

  /* ======================================================================
     PRODUCT PAGE
     ====================================================================== */
  function product(scope) {
    $$('[data-x-product]', scope).forEach(function (pp) {
      if (pp.dataset.xOn) return; pp.dataset.xOn = '1';

      /* gallery */
      var main = $('[data-x-main-media]', pp), thumbs = $$('[data-x-thumb]', pp), slides = $$('[data-x-slide]', pp), gi = 0;
      function show(i) {
        if (!slides.length) return; gi = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === gi); var v = $('video', s); if (v && k !== gi) v.pause(); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === gi); t.setAttribute('aria-current', k === gi ? 'true' : 'false'); });
        var at = thumbs[gi]; if (at && at.scrollIntoView) { var rail = at.parentNode; rail.scrollTo({ left: at.offsetLeft - rail.clientWidth / 2 + at.clientWidth / 2, behavior: 'smooth' }); }
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
      $$('[data-x-gal-prev]', pp).forEach(function (b) { b.addEventListener('click', function () { show(gi - 1); }); });
      $$('[data-x-gal-next]', pp).forEach(function (b) { b.addEventListener('click', function () { show(gi + 1); }); });
      if (main) {
        var tx = null;
        main.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) { if (tx === null) return; var d = e.changedTouches[0].clientX - tx; if (Math.abs(d) > 40) show(gi + (d < 0 ? 1 : -1)); tx = null; });
        if (fine) main.addEventListener('mousemove', function (e) {
          var img = $('.is-active img', main); if (!img) return; var r = main.getBoundingClientRect();
          img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        });
      }

      /* bundles */
      var cards = $$('[data-x-bundle]', pp), input = $('input[name="id"]', pp), atcPrice = $('[data-x-atc-price]', pp);
      var docks = $$('[data-x-dock-opt]');
      function selectVariant(id) {
        cards.forEach(function (c) { var on = c.getAttribute('data-x-bundle') === String(id); c.classList.toggle('is-active', on); c.setAttribute('aria-checked', on ? 'true' : 'false'); if (on && atcPrice) atcPrice.textContent = c.getAttribute('data-x-price-label') || ''; });
        docks.forEach(function (d) { var on = d.getAttribute('data-x-dock-opt') === String(id); d.classList.toggle('is-active', on); d.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        if (input) input.value = id;
        $$('[data-x-dock-price]').forEach(function (el) { var c = cards.filter(function (k) { return k.classList.contains('is-active'); })[0]; if (c) el.textContent = c.getAttribute('data-x-price-label') || ''; });
      }
      cards.forEach(function (c) {
        c.addEventListener('click', function () { selectVariant(c.getAttribute('data-x-bundle')); });
        c.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectVariant(c.getAttribute('data-x-bundle')); } });
      });
      docks.forEach(function (d) { d.addEventListener('click', function () { selectVariant(d.getAttribute('data-x-dock-opt')); }); });
      var first = cards.filter(function (c) { return c.classList.contains('is-active'); })[0] || cards[0];
      if (first) selectVariant(first.getAttribute('data-x-bundle'));

      /* sticky docks */
      var buy = $('[data-x-buy]', pp), dockEls = $$('[data-x-dock]');
      $$('[data-x-dock-atc]').forEach(function (b) {
        b.addEventListener('click', function () { var s = $('[data-x-buy] button[type="submit"]', pp); if (s && !s.disabled) s.click(); else if (buy) buy.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
      });
      var zones = [$('.x-bundles', pp), buy].filter(Boolean);
      if (zones.length && 'IntersectionObserver' in win) {
        var onScreen = [];
        var setDock = function (show) {
          dockEls.forEach(function (d) { d.classList.toggle('is-visible', show); });
          doc.body.classList.toggle('x-dock-open', show);
        };
        var zio = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            var i = onScreen.indexOf(e.target);
            if (e.isIntersecting && i < 0) onScreen.push(e.target);
            if (!e.isIntersecting && i > -1) onScreen.splice(i, 1);
          });
          setDock(onScreen.length === 0);
        }, { threshold: 0, rootMargin: '-70px 0px -90px 0px' });
        zones.forEach(function (z) { zio.observe(z); });
      }

      /* coupon copy */
      $$('[data-x-copy]', pp).forEach(function (el) {
        function go() {
          var code = el.getAttribute('data-x-copy'), lab = $('[data-x-copy-label]', el), orig = lab ? lab.innerHTML : '';
          function done() { el.classList.add('is-copied'); if (lab) lab.innerHTML = 'Copied! <b>' + code + '</b>'; setTimeout(function () { el.classList.remove('is-copied'); if (lab) lab.innerHTML = orig; }, 2000); }
          if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done).catch(done);
          else { var t = doc.createElement('textarea'); t.value = code; t.style.position = 'fixed'; t.style.opacity = '0'; doc.body.appendChild(t); t.select(); try { doc.execCommand('copy'); } catch (e) {} doc.body.removeChild(t); done(); }
        }
        el.addEventListener('click', go);
        el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
      });

      /* review slider */
      $$('[data-x-slider]', pp).forEach(function (box) {
        var sl = $$('[data-x-sl]', box), dots = $$('[data-x-dot]', box), cur = 0, tm;
        if (!sl.length) return;
        function go(i) { cur = (i + sl.length) % sl.length; sl.forEach(function (s, k) { s.classList.toggle('is-active', k === cur); }); dots.forEach(function (d, k) { d.classList.toggle('is-active', k === cur); }); }
        function auto() { clearInterval(tm); if (sl.length > 1 && !reduce) tm = setInterval(function () { go(cur + 1); }, 5500); }
        var p = $('[data-x-sl-prev]', box), n = $('[data-x-sl-next]', box);
        if (p) p.addEventListener('click', function () { go(cur - 1); auto(); });
        if (n) n.addEventListener('click', function () { go(cur + 1); auto(); });
        dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); auto(); }); });
        go(0); auto();
      });

      /* protect product imagery (same as before) */
      pp.addEventListener('contextmenu', function (e) { if (e.target.closest('[data-x-protect] img')) e.preventDefault(); });
      pp.addEventListener('dragstart', function (e) { if (e.target.closest('[data-x-protect] img')) e.preventDefault(); });
    });
  }

  /* purchase toast */
  function toast() {
    var t = $('[data-x-toast]'); if (!t || t.dataset.xOn) return; t.dataset.xOn = '1';
    var list; try { list = JSON.parse(t.getAttribute('data-x-toast')); } catch (e) { return; }
    if (!list || !list.length) return;
    if (t.parentNode !== doc.body) doc.body.appendChild(t);
    var nameEl = $('[data-x-toast-name]', t), prodEl = $('[data-x-toast-product]', t), i = 0;
    for (var k = list.length - 1; k > 0; k--) { var r = Math.floor(Math.random() * (k + 1)), tmp = list[k]; list[k] = list[r]; list[r] = tmp; }
    function show() {
      var p = list[i % list.length]; i++;
      nameEl.textContent = p.name; prodEl.textContent = p.product;
      t.classList.add('is-visible'); t.setAttribute('aria-hidden', 'false');
      setTimeout(function () { t.classList.remove('is-visible'); t.setAttribute('aria-hidden', 'true'); }, 5000);
    }
    setTimeout(function () { show(); setInterval(show, 10000); }, 4000);
  }

  /* collection sort */
  function sorters() {
    $$('[data-x-sort]').forEach(function (s) {
      s.addEventListener('change', function () { var u = new URL(win.location.href); u.searchParams.set('sort_by', s.value); win.location = u.toString(); });
    });
  }

  /* cart page qty */
  function cartQty() {
    $$('[data-x-qty]').forEach(function (w) {
      if (w.dataset.xOn) return; w.dataset.xOn = '1';
      var inp = $('input', w), form = w.closest('form');
      $$('button', w).forEach(function (b) {
        b.addEventListener('click', function () { var v = parseInt(inp.value || '0', 10) + (b.hasAttribute('data-x-plus') ? 1 : -1); inp.value = Math.max(0, v); if (form) { var u = doc.createElement('input'); u.type = 'hidden'; u.name = 'update'; u.value = '1'; form.appendChild(u); form.submit(); } });
      });
    });
  }

  function init(scope) {
    scan(scope);
    $$('[data-x-stars] canvas', scope).forEach(stars);
    $$('[data-x-tilt]', scope).forEach(tilt);
    $$('[data-x-magnet]', scope).forEach(magnet);
    $$('[data-x-parallax]', scope).forEach(function (el) { if (!reduce && px.indexOf(el) < 0) px.push(el); });
    reels(scope); marquees(scope); product(scope);
  }

  onReady(function () {
    /* mobile swipe rows: arrows + dots + auto-rotate */
    $$('[data-x-rail-nav]').forEach(function (nav) {
      var rail = nav.previousElementSibling; if (!rail) return;
      var items = rail.children, dots = $$('i', nav), idx = 0, paused = 0, timer;
      function active() { return rail.scrollWidth > rail.clientWidth + 8; }
      function current() {
        var best = 0, bd = 1e9, c = rail.scrollLeft + rail.clientWidth / 2;
        for (var n = 0; n < items.length; n++) { var it = items[n], d = Math.abs(it.offsetLeft + it.offsetWidth / 2 - c); if (d < bd) { bd = d; best = n; } }
        return best;
      }
      function go(n) {
        if (!items.length) return; idx = (n + items.length) % items.length; var it = items[idx];
        rail.scrollTo({ left: it.offsetLeft - (rail.clientWidth - it.offsetWidth) / 2, behavior: 'smooth' });
      }
      function hold() { paused = Date.now() + 7000; }
      rail.addEventListener('scroll', function () { idx = current(); dots.forEach(function (d, n) { d.classList.toggle('is-on', n === idx); }); }, { passive: true });
      ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) { rail.addEventListener(ev, hold, { passive: true }); });
      $('[data-x-rail-prev]', nav).addEventListener('click', function () { hold(); go(current() - 1); });
      $('[data-x-rail-next]', nav).addEventListener('click', function () { hold(); go(current() + 1); });
      var seen = true;
      if ('IntersectionObserver' in win) new IntersectionObserver(function (es) { seen = es[0].isIntersecting; }, { threshold: .3 }).observe(rail);
      timer = setInterval(function () { if (!active() || !seen || Date.now() < paused || doc.hidden) return; go(current() + 1); }, 3500);
    });
    init(doc); header(); overlays(); toast(); sorters(); cartQty();
    doc.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href="#x-top"]'); if (!a) return;
      e.preventDefault(); win.scrollTo({ top: 0, behavior: 'smooth' });
    });
    setTimeout(function () { $$('[data-x-reveal], [data-x-split]').forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < win.innerHeight) el.classList.add('is-in'); }); }, 1200);
  });
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); $$('[data-x-reveal], [data-x-split]', e.target).forEach(function (el) { el.classList.add('is-in'); }); });
})();
